var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/console-logger.ts
import {
  formatLogMessage,
  getConsoleMethod,
  isConsoleAvailable,
  mergeWithAsyncContext,
  resolveServiceName,
  shouldLog
} from "./shared.js";
var ClientLogger = class {
  static {
    __name(this, "ClientLogger");
  }
  serviceName;
  level;
  format;
  constructor(options = {}) {
    this.serviceName = resolveServiceName(options.serviceName, "pulse-client");
    this.level = options.level || "info";
    this.format = options.format || "string";
  }
  shouldLogLevel(logLevel) {
    return shouldLog(logLevel, this.level);
  }
  logWithLevel(level, message, context) {
    if (this.shouldLogLevel(level) && isConsoleAvailable()) {
      const mergedContext = mergeWithAsyncContext(context);
      const formattedMessage = formatLogMessage(level, message, {
        serviceName: this.serviceName,
        sessionId: void 0,
        context: mergedContext,
        format: this.format
      });
      const consoleMethod = getConsoleMethod(level);
      consoleMethod(formattedMessage);
    }
  }
  trace(message, context) {
    this.logWithLevel("trace", message, context);
  }
  debug(message, context) {
    this.logWithLevel("debug", message, context);
  }
  info(message, context) {
    this.logWithLevel("info", message, context);
  }
  warn(message, context) {
    this.logWithLevel("warn", message, context);
  }
  error(message, context) {
    this.logWithLevel("error", message, context);
  }
  fatal(message, context) {
    this.logWithLevel("fatal", message, context);
  }
  success(message, context) {
    this.logWithLevel("success", message, context);
  }
  fail(message, context) {
    this.logWithLevel("fail", message, context);
  }
  ready(message, context) {
    this.logWithLevel("ready", message, context);
  }
  start(message, context) {
    this.logWithLevel("start", message, context);
  }
  child(options) {
    const childLogger = Object.create(this);
    if (options.prefix) {
      childLogger.serviceName = `${this.serviceName}:${options.prefix}`;
    }
    childLogger.format = this.format;
    return childLogger;
  }
  /**
   * No-op flush for client-side (nothing to flush)
   */
  async flush() {
  }
  /**
   * HTTP logger not available on client-side
   */
  httpLogger() {
    throw new Error("HTTP logger is only available on server side");
  }
};
export {
  ClientLogger
};
